/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var r = /* @__PURE__ */ ((p) => (p[p.PopupList = 0] = "PopupList", p[p.TagsList = 1] = "TagsList", p))(r || {});
export {
  r as ActiveDescendant
};
